import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
type Review = {
  id: string;
  image: string;
  quote: string;
  name: string;
  title: string;
  eventType: string;
  rating: number;
};
const REVIEWS: Review[] = [{
  id: '1',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=400&q=80',
  quote: "Sips & Nibbles completely elevated our corporate gala. The cocktails were not only delicious but visually stunning, and the small chops were the talk of the evening. Their team's professionalism and attention to detail are unmatched.",
  name: 'SARAH JENKINS',
  title: 'DIRECTOR OF EVENTS, GLOBAL TECH INC.',
  eventType: 'Corporate Gala',
  rating: 5
}, {
  id: '2',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=80',
  quote: "I've worked with many hospitality vendors, but none bring the level of sophistication and flavor that Sips & Nibbles does. Their bespoke menu design perfectly captured the essence of our brand launch. Absolutely phenomenal.",
  name: 'MARCUS CHEN',
  title: 'FOUNDER, LUXE LIFESTYLE AGENCY',
  eventType: 'Brand Activation',
  rating: 5
}, {
  id: '3',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=400&q=80',
  quote: 'From the initial consultation to the final toast, the experience was flawless. The mixologists were true entertainers, and the gourmet bites were paired perfectly. They made our private celebration unforgettable.',
  name: 'ELENA RODRIGUEZ',
  title: 'PRIVATE CLIENT',
  eventType: 'Private Celebration',
  rating: 5
}];
export function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextReview = () => {
    setCurrentIndex(prev => (prev + 1) % REVIEWS.length);
  };
  const prevReview = () => {
    setCurrentIndex(prev => (prev - 1 + REVIEWS.length) % REVIEWS.length);
  };
  return <section className="w-full max-w-[95%] lg:max-w-[85%] mx-auto bg-white text-black py-16 md:py-24 border border-gray-200 mb-10 md:mb-20 overflow-hidden" data-id="element-195">
      <div className="max-w-6xl mx-auto px-6 md:px-10" data-id="element-196">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16" data-id="element-197">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-accent font-bold uppercase tracking-[0.2em] text-sm md:text-base" data-id="element-198">
            Client Experiences
          </motion.h2>

          <div className="flex gap-4" data-id="element-199">
            <button onClick={prevReview} className="p-3 border border-gray-300 rounded-full hover:bg-black hover:text-white hover:border-black transition-colors focus:outline-none" aria-label="Previous review" data-id="element-200">
              <ArrowBackIosNewIcon fontSize="small" data-id="element-201" />
            </button>
            <button onClick={nextReview} className="p-3 border border-gray-300 rounded-full hover:bg-black hover:text-white hover:border-black transition-colors focus:outline-none" aria-label="Next review" data-id="element-202">
              <ArrowForwardIosIcon fontSize="small" data-id="element-203" />
            </button>
          </div>
        </div>

        <div className="relative w-full" data-id="element-204">
          <AnimatePresence mode="wait" data-id="element-205">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex flex-col md:flex-row gap-6 md:gap-12 items-center md:items-start text-center md:text-left w-full" data-id="element-206">
              {/* Image */}
              <div className="w-32 sm:w-40 md:w-1/3 lg:w-1/4 shrink-0" data-id="element-207">
                <div className="relative aspect-square overflow-hidden rounded-full md:rounded-sm border-4 border-white shadow-xl mx-auto md:mx-0" data-id="element-208">
                  <img src={REVIEWS[currentIndex].image} alt={REVIEWS[currentIndex].name} className="absolute inset-0 h-full w-full object-cover" data-id="element-209" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 relative pt-2 md:pt-4 w-full" data-id="element-210">
                <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3 sm:gap-4 mb-6" data-id="element-211">
                  <div className="flex text-accent" data-id="element-212">
                    {[...Array(REVIEWS[currentIndex].rating)].map((_, i) => <StarIcon key={i} fontSize="small" data-id="element-213" />)}
                  </div>
                  <span className="text-[10px] sm:text-xs font-bold uppercase tracking-widest bg-gray-100 px-3 py-1 rounded-full text-gray-600" data-id="element-214">
                    {REVIEWS[currentIndex].eventType}
                  </span>
                </div>

                <div className="relative z-10" data-id="element-215">
                  <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-medium italic leading-relaxed text-gray-800 mb-6 md:mb-8" data-id="element-216">
                    "{REVIEWS[currentIndex].quote}"
                  </p>
                  <div data-id="element-217">
                    <h3 className="text-black font-black uppercase tracking-wider text-sm sm:text-base md:text-lg mb-1" data-id="element-218">
                      {REVIEWS[currentIndex].name}
                    </h3>
                    <p className="text-gray-500 text-[10px] sm:text-xs md:text-sm uppercase tracking-widest font-semibold" data-id="element-219">
                      {REVIEWS[currentIndex].title}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}